module.exports = __webpack_public_path__ + "media/images/challenges/golden-ticket-22/artstation-logo-01e3c31e12c77be1ef89e1e87c01ab9b.svg";